<template>
  <div>
    <transition name="route" mode="out-in">
      <PreLoader v-if="isStillLoading" />
    </transition>
    <div class="banner-join-our-team-Container">
      <img
        class="join-our-team-banner-desk-mob"
        :src="isSmallScreenBanner ? mobileBanner : desktopBanner"
        alt=""
      />
    </div>
    <div class="first-section-carrers-with-us-wrap">
      <div class="first-section-carrers-with-us">
        <div class="inner">
          <div class="text-wrap">
            <div class="col">
              <div class="heading">
                <p>
                  <img
                    decoding="async"
                    width="200"
                    height="77"
                    class="ls-is-cached lazyloaded"
                    :src="this.publicPath+'assets/images/logo.png'"
                  />
                </p>
              </div>
              <div class="text introduction">
                <p>
                  The Ear Casino is a provider of iGaming content, unlocking
                  exciting opportunities for gaming through a unified API. Our
                  diverse product lineup includes top-notch slot games, live
                  casino experiences, virtual sports, bingo, sports betting, and
                  more, all accessible in major, well-regulated markets.
                </p>
                <p>
                  Fueled by an unwavering commitment to create captivating
                  entertainment experiences, we continually produce games that
                  resonate with players.
                </p>
              </div>
            </div>
            <div class="col">
              <div class="side-text">
                <img
                  decoding="async"
                  class="ls-is-cached lazyloaded"
                  :src="this.publicPath+'assets/images/api.png'"
                />
                Supplier of high-quality iGaming content
              </div>
              <div class="side-text">
                <img
                  decoding="async"
                  class="ls-is-cached lazyloaded"
                  :src="this.publicPath+'assets/images/license.png'"
                />
                Certified and licensed
              </div>
              <div class="side-text">
                <img
                  decoding="async"
                  class="ls-is-cached lazyloaded"
                  :src="this.publicPath+'assets/images/award2.png'"
                />
                Socially responsible
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="want-to-be-part-of-our-team">
      <div class="inner">
        <div class="text-wrap text-center">
          <div class="col">
            <div class="heading">
              <h3 class="mb-2">
                Want to be part of&nbsp;<span class="colored-text"
                  >our team?</span
                >
              </h3>
            </div>
            <div class="text">
              <p>Let's see our openings!</p>
            </div>
            <div class="button-see-job-opportunity">
              <a
                target="_blank"
                href="https://www.linkedin.com/company/the-ear-casino/jobs/"
                >The Ear Casino</a
              >
              <a
                target="_blank"
                href="https://www.linkedin.com/company/the-ear-limited/jobs/"
                >The Ear Platform</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <Carrers_WhatWeSearch />
    <OurLocations />
  </div>
</template>

<script>
import PreLoader from "@/components/Global/PreLoader.vue";
import Carrers_WhatWeSearch from "@/components/UI/Carrers_WhatWeSearch.vue";
import OurLocations from "@/components/UI/OurLocations.vue";
export default {
  name: "CarrerWithUS",
  components: {
    PreLoader,
    Carrers_WhatWeSearch,
    OurLocations,
  },

  data() {
    return {
      lang: localStorage.getItem("language") ?? "en",
      isStillLoading: true,
      publicPath:process.env.VUE_APP_PUBLIC_PATH ?? "/",
      isSmallScreenBanner: window.innerWidth <= 600,
      mobileBanner:  this.publicPath+"assets/images/CaroselloBanner/joinourteam_mobile.png",
      desktopBanner: this.publicPath+"assets/images/CaroselloBanner/joinourteam_desktop.png",
    };
  },
  computed: {},
  mounted() {
    window.addEventListener("resize", () => {
      this.isSmallScreenBanner = window.innerWidth <= 600;
    });
  },
  created() {
    let lang = localStorage.getItem("language") ?? "en";
    this.$router.push({ params: { lang: lang } });
    document.body.style.fontFamily = "Poppins, sans-serif";
    this.setMetaTags();
    this.timeout();
  },
  methods: {
    timeout() {
      document.body.style.overflow='hidden';
      document.documentElement.style.overflow='hidden';
      setTimeout(() => {
        document.body.style.overflow='';
        document.documentElement.style.overflow='';
        this.isStillLoading = false;
      }, 1500);
    },
    setMetaTags() {
      const title = "The Ear | Careers with Us";
      const metaDescription =
        "Join Our Team and Shape the Future! Explore Exciting Career Opportunities with Us.";

      document.title = title;

      const metaDescriptionTag = document.querySelector(
        'meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.setAttribute("content", metaDescription);
      } else {
        const newMetaTag = document.createElement("meta");
        newMetaTag.name = "description";
        newMetaTag.content = metaDescription;
        document.head.appendChild(newMetaTag);
      }
    },
  },
};
</script>

<style scoped>
.first-section-carrers-with-us-wrap {
  position: relative;
  margin-top: -5px;
}

.want-to-be-part-of-our-team {
  background: black;
}

.banner-join-our-team-Container {
  padding: 75px 0px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: #112b53;
}

.banner-join-our-team-Container img {
  max-width: 100%;
  height: auto;
  -o-object-fit: cover;
  object-fit: cover;
}

.first-section-carrers-with-us {
  background-color: #09041f;
  box-shadow: 0 0 35px 0 rgba(0, 0, 0, 0.1);
}

.first-section-carrers-with-us .inner .text-wrap {
  display: flex;
  align-items: center;
}

.first-section-carrers-with-us .inner .text-wrap .col {
  width: 50%;
  margin: 0px 20px;
}

.introduction p {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 30px;
  margin: 0;
  margin-bottom: 20px;
}

.first-section-carrers-with-us .inner .text-wrap .col .side-text img {
  height: 66px;
  width: 67px;
  margin-right: 35px;
}
.lazyloaded {
  opacity: 1;
  transition: opacity 400ms;
  transition-delay: 0ms;
}

.first-section-carrers-with-us .inner .text-wrap .col .side-text {
  display: flex;
  align-items: center;
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 25px;
  padding-bottom: 30px;
}

@media only screen and (max-width: 768px) {
  .first-section-carrers-with-us .inner {
    padding-top: 45px;
    padding-bottom: 45px;
  }
  .first-section-carrers-with-us .inner .text-wrap {
    flex-direction: column;
  }
  .first-section-carrers-with-us .inner .text-wrap .col {
    width: 100%;
  }

  .first-section-carrers-with-us .inner .text-wrap .col .heading > * {
    font-size: 28px;
    line-height: 42px;
  }

  .first-section-carrers-with-us .inner .text-wrap .col:last-of-type {
    margin: 0;
    margin-top: 40px;
  }

  .first-section-carrers-with-us .inner .text-wrap .col .side-text {
    font-size: 14px;
    line-height: 21px;
  }
}

@media (max-width: 1239px) {
  .first-section-carrers-with-us .inner .text-wrap {
    padding-left: 20px;
    padding-right: 20px;
  }
}

.first-section-carrers-with-us .inner {
  max-width: 1200px;
  margin: auto;
  color: #ffffff;
  padding-top: 85px;
  padding-bottom: 40px;
  /* padding-top: 85px;
  padding-bottom: 85px; */
}

@media only screen and (min-width: 992px) {
  .want-to-be-part-of-our-team {
    /* position: relative;
    top: -200px;
    max-height: 35vh;
    z-index: 2; */
    position: relative;
    /* top: -60px; */
    max-height: 350px;
    /* min-height: 35vh; */
    z-index: 2;
  }
}
@media only screen and (max-width: 991px) {
  .want-to-be-part-of-our-team {
    position: relative;
    /* top: -260px; */
    z-index: 2;
    max-height: 50vh;
  }
}

@media only screen and (max-width: 768px) {
  .want-to-be-part-of-our-team .inner {
    max-width: 1400px;
    margin: 0px 30px !important;
    color: #ffffff;
    /* padding-top: 85px;
    padding-bottom: 85px; */
    padding-top: 30px !important;
    padding-bottom: 30px !important;
  }
}

.want-to-be-part-of-our-team .inner .text-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* //questo controlla */
.want-to-be-part-of-our-team .inner {
  max-width: 1400px;
  margin: auto;
  color: #ffffff;
  padding-top: 15px;
  padding-bottom: 45px;
}

.want-to-be-part-of-our-team .inner .text-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.want-to-be-part-of-our-team .inner .text-wrap .heading > * {
  font-family: "Montserrat", sans-serif;
  font-size: 32px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 48px;
  margin: 0;
}

.colored-text {
  display: contents;
  color: #e77842 !important;
}

.want-to-be-part-of-our-team .inner .text-wrap a {
  box-sizing: border-box;
  height: 45px;
  min-width: 185px;
  margin: 10px 10px;
  padding-left: 20px;
  padding-right: 20px;
  border: 2px solid #3c89aa;
  border-radius: 23px;
  background-color: #3c89aa;
  box-shadow: 0 0 5px 5px #3c89aa;
  display: inline-flex;
  text-decoration: none;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 1.44;
  outline: none;
  transition: border-color 0.5s, background-color 0.5s, color 0.5s,
    box-shadow 0.5s, color 0.5s, 0.3s all;
}

.button-see-job-opportunity a:hover {
  transform: scale(1.02);
  transition: 0.3s all;
  box-shadow: 0 0 8px 5px #327d9e;
  text-decoration: underline !important;
  filter: brightness(80%);
}

.button-see-job-opportunity {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  overflow: hidden;
}
</style>
